(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-boxes-2"]) return;
  try {
    
  $.validator.methods.email = function( value, element ) {
      return this.optional( element ) || /[a-z]+@[a-z]+\.[a-z]+/.test( value );
  }

  function changeDisplayImg(){  
	$('.rad-form-div .rad-boxes-img img').hide();
    var boxStyle = $('[name="package_style"]').val();
    var materialN = $('[name="viewer_inputs_material"]').val();
    switch(boxStyle){
      case 'Folding Carton':
      boxStyle = 'Carton';
      break;

      case 'Tuck Top Mailer':
      boxStyle = 'Mailer';
      break;
    }
    if((typeof $('#'+boxStyle+'-'+materialN+'-img').attr('src')) != 'undefined'){
		$('#'+boxStyle+'-'+materialN+'-img').show();     
    }
  }

  $(document).ready(function(){
    
    $( "#rad-delivery-date" ).datepicker({ minDate: 0 });
    
    $('input[name="input_artwork"]').change(function(){
      if($(this).is(':checked')){
        $(this).parents('.rad-artwork-check-div').hide();
      	$('.rad-artwork-link').show();
      }
    });
    
    $('[name="package_style"], [name="viewer_inputs_material"]').change(function(e){
      changeDisplayImg();
    });
    
    $('[name="package_style"]').trigger('change');
    
    $("#form-quote-request").validate({
      rules: {
        firstname: {
          required: true,
        },
        lastname: {
          required: true,
        },
        email: {
          required: true,
          email: true
        },
        package_style: {
          required: true
        },
        quantity: {
          required: true,
          min: 1
        },
        input_zip: {
          required: true,
        },
        viewer_inputs_material: {
          required: true,
        },
        colors: {
          required: true,
        },
        artwork_file: {
          extension: "pdf"
        }
      },
      submitHandler: function(form) {
        // some other code
        // maybe disabling submit button
        // then:
        
        $('.modal-footer .text-danger').html('');
        $(form).find('#rad-submit-btn').prop('disabled',true);
        $(form).find('#rad-submit-btn').val('Sending...');
        
        var form = $(form)[0];
        var fromVal = new FormData(form);
        //var fromVal = $(form).serialize();
        $.ajax({            
            type: "POST",
            enctype: 'multipart/form-data',
            url: 'http://arboxpackaging.com/mail/rad-mail.php',
            data: fromVal,
            processData: false,
            contentType: false,
            success: function(data) {
              var obj = $.parseJSON(data);
              if(obj.status == 'success'){
                $('.modal-footer .text-danger').html('<label class="valid">'+obj.message+'</label>');
                $(form)[0].reset();
              }else if(obj.status == 'fail'){
                $('.modal-footer .text-danger').html('<label class="error">'+obj.message+'</label>');
              }else{
                $('.modal-footer .text-danger').html('<label class="error">Unexpected error occured!</label>');
              }
              
              $(form).find('#rad-submit-btn').prop('disabled',false);
        	  $(form).find('#rad-submit-btn').val('Send');
                
            },
            error: function(jqXHR, textStatus, errorThrown) {
                /*var errorMessage = jqXHR.responseText;
                if (errorMessage.length > 0) {
                    alert(errorMessage);
                }*/
              $('.modal-footer .text-danger').html('<label class="error">Unexpected error occured!</label>');
              $(form).find('#rad-submit-btn').prop('disabled',false);
        	  $(form).find('#rad-submit-btn').val('Send');
            }
        });
      }
    });
    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-boxes"]) return;
  try {
    
  $.validator.methods.email = function( value, element ) {
      return this.optional( element ) || /[a-z]+@[a-z]+\.[a-z]+/.test( value );
  }

  function changeDisplayImg(){  
	$('.rad-form-div .rad-boxes-img img').hide();
    var boxStyle = $('[name="package_style"]').val();
    var materialN = $('[name="viewer_inputs_material"]').val();
    switch(boxStyle){
      case 'Shipper':
      boxStyle = 'Carton';
      break;

      case 'Tuck Top Mailer':
      boxStyle = 'Mailer';
      break;
    }
    if((typeof $('#'+boxStyle+'-'+materialN+'-img').attr('src')) != 'undefined'){
		$('#'+boxStyle+'-'+materialN+'-img').show();     
    }
  }

  $(document).ready(function(){
    
    $( "#rad-delivery-date" ).datepicker({ minDate: 0 });
    
    $('input[name="input_artwork"]').change(function(){
      if($(this).is(':checked')){
        $(this).parents('.rad-artwork-check-div').hide();
      	$('.rad-artwork-link').show();
      }
    });
    
    $('[name="package_style"], [name="viewer_inputs_material"]').change(function(e){
      changeDisplayImg();
    });
    
    $('[name="package_style"]').trigger('change');
    
    $("#form-quote-request").validate({
      rules: {
        firstname: {
          required: true,
        },
        lastname: {
          required: true,
        },
        email: {
          required: true,
          email: true
        },
        package_style: {
          required: true
        },
        quantity: {
          required: true,
          min: 1
        },
        input_zip: {
          required: true,
        },
        viewer_inputs_material: {
          required: true,
        },
        colors: {
          required: true,
        },
        artwork_file: {
          extension: "pdf"
        }
      },
      submitHandler: function(form) {
        // some other code
        // maybe disabling submit button
        // then:
        
        $('.modal-footer .text-danger').html('');
        $(form).find('#rad-submit-btn').prop('disabled',true);
        $(form).find('#rad-submit-btn').val('Sending...');
        
        var form = $(form)[0];
        var fromVal = new FormData(form);
        //var fromVal = $(form).serialize();
        $.ajax({            
            type: "POST",
            enctype: 'multipart/form-data',
            url: 'https://arboxpackaging.com/mail/rad-mail.php',
            data: fromVal,
            processData: false,
            contentType: false,
            success: function(data) {
              var obj = $.parseJSON(data);
              if(obj.status == 'success'){
                $('.modal-footer .text-danger').html('<label class="valid">'+obj.message+'</label>');
                $(form)[0].reset();
              }else if(obj.status == 'fail'){
                $('.modal-footer .text-danger').html('<label class="error">'+obj.message+'</label>');
              }else{
                $('.modal-footer .text-danger').html('<label class="error">Unexpected error occured!</label>');
              }
              
              $(form).find('#rad-submit-btn').prop('disabled',false);
        	  $(form).find('#rad-submit-btn').val('Send');
                
            },
            error: function(jqXHR, textStatus, errorThrown) {
                /*var errorMessage = jqXHR.responseText;
                if (errorMessage.length > 0) {
                    alert(errorMessage);
                }*/
              $('.modal-footer .text-danger').html('<label class="error">Unexpected error occured!</label>');
              $(form).find('#rad-submit-btn').prop('disabled',false);
        	  $(form).find('#rad-submit-btn').val('Send');
            }
        });
      }
    });
    
  });

  } catch(e) { console.error(e); }
})();
})();
